import {Badge} from '@common-web/components/ui/badge';

export function RoleStatusBadge({role}: {role: {source: string; isDeprecated: boolean}}) {
  if (role.isDeprecated) {
    return (
      <Badge className='bg-amber/10 text-amber border border-amber/30 font-medium'>
        No longer in use
      </Badge>
    );
  }
  if (role.source === 'SYSTEM') {
    return (
      <Badge className='bg-emerald/10 text-emerald border border-emerald/30 font-medium'>
        Built-in
      </Badge>
    );
  }
  return (
    <Badge className='bg-brand-blue/10 text-brand-blue border border-brand-blue/30 font-medium'>
      Custom
    </Badge>
  );
}
